import { Component } from "react";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import ListBanquesToPayement from "../../../models/ListBanquesToPayement";
// original import UploadFileService from "../../../services/UploadFileService";
import BCService from "../../../services/BC";
import UploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import { TextField } from "@material-ui/core";
import SellingService from "../../../services/SellingService";

class PayementBCCheque extends Component {
  state = {
    codePayementCheque: "",
    amount: "",
    amountMax: "",
    datePayementCheque: "",
    selectedFile: null,
    urlFile: "",
    fileName: "Chèque/ traite",
  };

  constructor(props) {
    super(props);
    this.state = {
      codePayementCheque: "",
      amount: "",
      amountMax: "",
      datePayementCheque: "",
      selectedFile: null,
      urlFile: "",
      fileName: "Chèque/ traite",
    };

    this.changeCodePayementCheque = this.changeCodePayementCheque.bind(this);
    this.changeDatePayementCheque = this.changeDatePayementCheque.bind(this);
    this.changeAmount = this.changeAmount.bind(this);
    //original  this.UploadFile = this.UploadFile.bind(this);
    this.onFileChangeHandler = this.onFileChangeHandler.bind(this);
  }
  refreshPage() {
    localStorage.removeItem("banqueAccount");
    window.location.reload(true);
  }
  changeCodePayementCheque(event) {
    this.setState({ codePayementCheque: event.target.value });
  }
  changeDatePayementCheque(event) {
    this.setState({ datePayementCheque: event.target.value.concat(":59") });
  }

  changeAmount(event) {
    // var amount = event.target.value;
    // if (amount > this.state.amountMax) {
    //   this.setState({ alert_message: "error" });
    // } else {
    this.setState({ amount: event.target.value });
    // }

    // console.log("amount", this.state.amount);
  }

  onFileChangeHandler = (event) => {
    if (event.target.files[0].size > 2097152) {
      toast.info("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      this.setState({
        fileName: event.target.files[0].name,
      });
      this.setState({
        selectedFile: event.target.files[0],
        loaded: 0,
      });
    }
  };

  payerBill = (e) => {
    if (this.state.codePayementCheque === "") {
      toast.error("Erreur : le champ  code chéque est vide");
    } else if (this.state.datePayementCheque === "") {
      toast.error("Erreur : le champ  date de l'échéance est vide");
    } else if (this.state.amount === "") {
      toast.error("Erreur : le champ montant  est vide");
    } else if (localStorage.getItem("banqueAccount") == null) {
      toast.error("Erreur : le champ compte bancaire est vide");
    } else {
      let payFactureOrAvance = {
        idUser: getCurrentUserId(),
        isFactureOrBDC: 0,
        idDocument: parseInt(localStorage.getItem("idBC")),
        isAvanceOrTotalPayement: 0,
        typePayement: 2,
        echanceDate: this.state.datePayementCheque,
        ammountPayed: this.state.amount,
        urlFile: "any",
        banqueAccountId: parseInt(localStorage.getItem("banqueAccount")),

        codeCheque: this.state.codePayementCheque,
      };
      console.log("payFactureOrAvance",payFactureOrAvance)
      if (localStorage.getItem("isIncome") === "ACHAT") {
        if (this.state.selectedFile != null) {
          const uploadData = new FormData();
          uploadData.append("picture", this.state.selectedFile);

          UploadAndDownloadService.uploadFile(
            "/retail/uploadFile/uploadFile/Payement",
            uploadData
          )
            .then((response) => {
              if (response.data["success"]) {
                payFactureOrAvance.urlFile = response.data["success"];

                BCService.payFactureOrBDC(payFactureOrAvance)

                  .then((response) => {
                    if (response.data["error"]) {
                      toast.error("Error : il ya un probléme");
                    } else {
                      toast.success("ajouté avec succès");

                      this.refreshPage();
                    }
                  })
                  .catch((error) => {
                    toast.error("Error : il ya un probléme");

                    this.refreshPage();
                  });
              } else {
                toast.error("Erreur : il ya un probléme au niveau de serveur");
              }
            })
            .catch(() => {
              toast.error("Erreur : il ya un probléme de connection");
            });

          e.preventDefault();
        } else {
          BCService.payFactureOrBDC(payFactureOrAvance)
            .then((response) => {
              if (response.data["error"]) {
                toast.error("Error : il ya un probléme");
              } else {
                toast.success("ajouté avec succès");

                this.refreshPage();
              }
            })
            .catch((error) => {
              toast.error("Error : il ya un probléme");

              this.refreshPage();
            });
        }
      } else if (localStorage.getItem("isIncome") === "VENTE") {
        if (this.state.selectedFile != null) {
          const uploadData = new FormData();
          uploadData.append("picture", this.state.selectedFile);

          UploadAndDownloadService.uploadFile(
            "/retail/uploadFile/uploadFile/Payement",
            uploadData
          )
            .then((response) => {
              if (response.data["success"]) {
                payFactureOrAvance.urlFile = response.data["success"];

                SellingService.payFactureOrBDC(payFactureOrAvance)

                  .then((response) => {
                    if (response.data["error"]) {
                      toast.error("Error : il ya un probléme");
                    } else {
                      toast.success("ajouté avec succès");

                      this.refreshPage();
                    }
                  })
                  .catch((error) => {
                    toast.error("Error : il ya un probléme");

                    this.refreshPage();
                  });
              } else {
                toast.error("Erreur : il ya un probléme au niveau de serveur");
              }
            })
            .catch(() => {
              toast.error("Erreur : il ya un probléme de connection");
            });

          e.preventDefault();
        } else {
          SellingService.payFactureOrBDC(payFactureOrAvance)
            .then((response) => {
              if (response.data["error"]) {
                toast.error("Error : il ya un probléme");
              } else {
                toast.success("ajouté avec succès");

                this.refreshPage();
              }
            })
            .catch((error) => {
              toast.error("Error : il ya un probléme");

              this.refreshPage();
            });
        }
      }
    }
  };
  render() {
    return (
      <div className="card-body">
        <ToastContainer />

        <br />
        <br />
        <div className="row">
          <div className="col-12">
            <label>Payement chèque / traite: </label>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <label>Compte bancaire </label>
            <ListBanquesToPayement type={1} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <label>Montant : </label>
            <input
              className="form-control"
              placeholder="Montant "
              name="amount"
              type="number"
              value={this.state.amount}
              onChange={this.changeAmount}
            />
          </div>
          <div className="col-md-4">
            <label>Code Chèque: </label>

            <input
              value={this.state.codePayementCheque}
              onChange={this.changeCodePayementCheque}
              class="form-control"
              placeholder="Code du chéque"
            />
          </div>

          <div className="col-md-4">
            <label>Date de l'échéance </label>
            <br />

            <TextField
              style={{ width: "100%" }}
              className="col-sm-12"
              variant="outlined"
              value={this.state.datePayementCheque}
              onChange={this.changeDatePayementCheque}
              id="datetime-local"
              type="datetime-local"
              defaultValue="date"
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="form-group ">
              <label for="exampleInputFile"> Ajouter le chèque </label>
              <div class="custom-file">
                <input
                  type="file"
                  accept="application/pdf,.jpg, .jpeg, .png"
                  className="custom-file-input"
                  name="file"
                  id="exampleInputFile"
                  onChange={this.onFileChangeHandler}
                />
                <label class="custom-file-label" for="exampleInputFile">
                  {this.state.fileName}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <button
            type="submit"
            onClick={this.payerBill}
            className="btn btn-dark float-right"
          >
            Payer
          </button>
        </div>
      </div>
    );
  }
}
export default PayementBCCheque;
